
<div>
  <input
    :id="inputId"
    :name="name"
    type="checkbox"
    :checked="shouldBeChecked"
    :value="value"
    :class="checkboxClasses"
    :disabled="isDisabled"
    :tabindex="tabIndex"
    @change="updateInput"
    @click="removeMouseFocus"
  />
  <label :class="checkboxLabelClasses" :for="inputId" :aria-label="ariaLabel">
    {{ labelName }}
    <span v-if="formattedLabelText" v-html="formattedLabelText"></span>
  </label>
  <div v-if="helperText" :id="ariaDescribedByName" class="mt-4 flex relative" :class="helperClasses">
    <ErrorIcon v-if="hasError" class="mr-4 mt-4" />
    <p class="text-field-helper">{{ helperText }}</p>
  </div>
</div>
